import React from 'react';
import Marquee from 'react-fast-marquee';

import { useLayoutContext } from '@ott/layout-context';

import FadeIn from 'src/components/elements/FadeIn';
import GradientButton from 'src/components/elements/GradientButton';

import metrics from 'src/utility/metrics';

import { APP_URL } from '../../constants';
import { CAROUSEL_IMAGES } from './constants';

import styles from './CarouselBlock.scss';

const CarouselBlock = () => {
  const { isDesktop } = useLayoutContext();

  const downloadClick = (event) => {
    event.preventDefault();
    metrics('SOLAR_LANDING_INSTALL_BUTTON', { trigger: 'carousel block' });
    window.open(APP_URL);
  };

  return (
    <div className={styles.carouselBlock}>
      <div className={styles.carousel}>
        <Marquee
          className={styles.marquee}
          gradient={true}
          gradientColor={[0, 0, 0]}
          gradientWidth={100}
          speed={1.5}
        >
          {CAROUSEL_IMAGES.slice(0, 4).map((image) => (
            <img
              key={image.id}
              className={styles.carouselImage}
              src={isDesktop ? image.src.desktop : image.src.mobile}
              alt="carouse-image"
              draggable="false"
            />
          ))}
        </Marquee>
        <Marquee
          className={styles.marquee}
          gradient={true}
          gradientColor={[0, 0, 0]}
          gradientWidth={100}
          speed={4}
          direction="right"
        >
          {CAROUSEL_IMAGES.slice(4, 8).map((image) => (
            <img
              key={image.id}
              className={styles.carouselImage}
              src={isDesktop ? image.src.desktop : image.src.mobile}
              alt="carouse-image"
              draggable="false"
            />
          ))}
        </Marquee>
        <Marquee
          className={styles.marquee}
          gradient={true}
          gradientColor={[0, 0, 0]}
          gradientWidth={100}
          speed={2.5}
        >
          {CAROUSEL_IMAGES.slice(8, 12).map((image) => (
            <img
              key={image.id}
              className={styles.carouselImage}
              src={isDesktop ? image.src.desktop : image.src.mobile}
              alt="carouse-image"
              draggable="false"
            />
          ))}
        </Marquee>
        <Marquee
          className={styles.marquee}
          gradient={true}
          gradientColor={[0, 0, 0]}
          gradientWidth={100}
          speed={2}
          direction="right"
        >
          {CAROUSEL_IMAGES.slice(12, 16).map((image) => (
            <img
              key={image.id}
              className={styles.carouselImage}
              src={isDesktop ? image.src.desktop : image.src.mobile}
              alt="carouse-image"
              draggable="false"
            />
          ))}
        </Marquee>
      </div>

      <div className={styles.title}>
        <FadeIn>
          <span>Curated{!isDesktop && <br />} stays & flights.</span>
        </FadeIn>
        <FadeIn delay={1}>
          <span className={styles.titleThin}>You're all booked!</span>
        </FadeIn>
      </div>

      <FadeIn className={styles.description} delay={2}>
        <span>
          A neo platform with innovative features
          <br /> perfects your journeys with every tap
        </span>
      </FadeIn>

      {!isDesktop && (
        <GradientButton
          className={styles.downloadButton}
          darkGradient={true}
          onClick={downloadClick}
        >
          Download app
        </GradientButton>
      )}
    </div>
  );
};

export default CarouselBlock;
